import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import AddIcon from "@material-ui/icons/Add";
import { httpClient } from "api/httpClient";
import { useSimpleModalToggle } from "components/dialogs/useSimpleModal";
import React from "react";
import { FormWithRedirect, useNotify, useRefresh, useTranslate } from "react-admin";
import { useNotifyError } from "utils/notifiers/useNotifyError";

import { AddDocumentTemplateBody } from "./AddEditDocumentTemplateBody";
import { TemplateInfoPreviewButton, TemplateInfoPreviewDialog } from "./TemplateInfoPreviewButton";
import { ValidationDetailsPreviewDialog } from "./ValidationDetailsPreviewDialog";

export const AddDocumentTemplate = (props) => {
	const [isLoading, setIsLoading] = React.useState(false);
	const [isInfoDialogOpen, setIsInfoDialogOpen] = React.useState(false);
	const [formValues, setFormValues] = React.useState({});
	const [isValidationDetailsOpen, setIsValidationDetailsOpen] = React.useState(false);
	const [validationDetails, setValidationDetails] = React.useState({});

	const refresh = useRefresh();
	const notify = useNotify();
	const notifyError = useNotifyError();
	const translate = useTranslate();
	const { open, handleOpen, handleClose } = useSimpleModalToggle();

	const handleSubmit = (values) => {
		setIsLoading(true);
		const data = new FormData();
		data.append("name", values.name);
		data.append("type", values.type);
		data.append("file", values.file.rawFile);
		if (props.companyId) {
			data.append("company_id", props.companyId);
		}
		if (props.terminalId) {
			data.append("terminal_id", props.terminalId);
		}

		httpClient("document-templates", { method: "POST", body: data })
			.then((res) => {
				handleClose();
				refresh();
				notify(translate("osfc.dialogs.document-templates.add.success"), "success");
			})
			.catch((error) => {
				if (error.body?.body?.details) {
					setValidationDetails(error.body.body.details);
					validationDetailsCloseDialogToggle();
				}
				notifyError(error);
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	const infoDialogToggle = () => {
		setIsInfoDialogOpen((prev) => !prev);
	};

	const validationDetailsCloseDialogToggle = () => {
		setIsValidationDetailsOpen((prev) => {
			if (prev) {
				setValidationDetails({});
			}
			return !prev;
		});
	};

	return (
		<>
			<Button
				aria-label="create"
				size="small"
				color="primary"
				startIcon={<AddIcon />}
				onClick={handleOpen}
			>
				{translate("resources.document-template.create-button")}
			</Button>
			{open && (
				<Dialog open={true} maxWidth="md" onClose={handleClose}>
					<DialogTitle>{translate("resources.document-template.create.title")}</DialogTitle>
					<FormWithRedirect
						submitOnEnter={false}
						component={DialogContent}
						save={handleSubmit}
						render={({ handleSubmitWithRedirect, form, record }) => (
							<React.Fragment>
								<AddDocumentTemplateBody
									form={form}
									handleValuesOnChange={setFormValues}
									isDefaultDocTemplate={!props.companyId ? true : false}
									enumObj={props.enumObj}
								/>
								<DialogActions>
									{!!formValues?.type && (
										<TemplateInfoPreviewButton
											translate={translate}
											onInfoButtonClick={infoDialogToggle}
										/>
									)}
									<Button disabled={isLoading} onClick={handleClose} color="primary">
										{translate("ra.action.cancel")}
									</Button>
									<Button disabled={isLoading} onClick={handleSubmitWithRedirect} color="primary">
										{translate("ra.action.add")}
									</Button>
								</DialogActions>
							</React.Fragment>
						)}
					/>
				</Dialog>
			)}
			{open && isInfoDialogOpen && !isValidationDetailsOpen && (
				<TemplateInfoPreviewDialog
					translate={translate}
					documentTemplateType={formValues.type}
					onInfoDialogClose={infoDialogToggle}
					companyId={props.companyId}
				/>
			)}
			{open && !isInfoDialogOpen && isValidationDetailsOpen && (
				<ValidationDetailsPreviewDialog
					translate={translate}
					onValidationDetailsDialogClose={validationDetailsCloseDialogToggle}
					validationDetails={validationDetails}
				/>
			)}
		</>
	);
};
